// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yodiwo-list-item {
  cursor: pointer;
  margin: 0px;
  padding: 0px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.yodiwo-list-item:hover:not(.no-hover) {
  background-color: rgba(0, 0, 0, 0.05);
}
.yodiwo-list-item #icon {
  font-size: 16px;
  margin: 12px;
}
.yodiwo-list-item #yodiwo-list-item-body {
  font-size: 16px;
  margin-left: 0px;
  flex: 1;
  padding: 10px;
}
.yodiwo-list-item #yodiwo-list-item-body #primaryText {
  font-size: 14px;
}
.yodiwo-list-item #yodiwo-list-item-body #secondaryText {
  font-size: 14px;
  height: 16px;
  margin: 4px 0px 0px;
  color: rgba(0, 0, 0, 0.54);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.yodiwo-list-item #arrow {
  width: 40px;
  top: 12px;
  right: 4px;
  margin: 0;
  padding: 10px;
  font-size: 16px;
}
.yodiwo-list-item-nested-items {
  margin-left: 16px;
  padding: 10px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
